























































import { Component } from 'vue-property-decorator';
import CartItem from '@/components/cart/CartItem.vue';
import CartBase from '@/components/cart/CartBase';

@Component({
  components: {
    CartItem,
  },
})
export default class CartPopup extends CartBase {
  protected isExpanded = true;
}
